import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Tela com erro:", error, info?.componentStack);
  }

  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="mx-auto max-w-lg mt-10 rounded-2xl border border-amber-800/60 bg-amber-950/20 p-6 text-center">
        <AlertTriangle className="h-8 w-8 text-amber-400 mx-auto" />
        <h2 className="mt-3 text-lg font-bold text-zinc-100">Ops, esta tela teve um problema</h2>
        <p className="mt-2 text-sm text-zinc-400">Seus dados estão salvos. Tente recarregar a página; se continuar, fale com o suporte.</p>
        <div className="mt-5 flex justify-center gap-3">
          <button data-testid="error-boundary-reload" onClick={() => window.location.reload()} className="rounded-full bg-green-600 px-5 py-2 text-sm font-bold text-white hover:bg-green-500 transition-colors">Recarregar</button>
          <button data-testid="error-boundary-back" onClick={() => window.history.back()} className="rounded-full border border-zinc-700 px-5 py-2 text-sm text-zinc-200 hover:bg-zinc-800 transition-colors">Voltar</button>
        </div>
      </div>
    );
  }
}
